import { EMEARegion } from "@dana/Common/Constants";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

const useIsEmea = (state: ApplicationState): boolean => {
    const currentLanguage = state.context.session.language;
    const isEMEA = currentLanguage?.properties?.region === EMEARegion;
    return isEMEA;
};

export default useIsEmea;
